import { render, staticRenderFns } from "./SelectCommodityPopUps.vue?vue&type=template&id=de39dd3c&scoped=true&"
import script from "./SelectCommodityPopUps.vue?vue&type=script&lang=js&"
export * from "./SelectCommodityPopUps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de39dd3c",
  null
  
)

export default component.exports